import { Link } from 'react-router-dom';
import { cn } from '@/lib/cn.js';

export const LOGO_SRC = '/assets/images/web/newLogo/ISBM26-Logo-aw-arsh-white.png';

export function SiteLogo({ className, linkClassName }) {
  return (
    <Link
      to="/"
      className={cn('inline-flex items-center group no-tap-highlight shrink-0', linkClassName)}
      aria-label="ISBM 2026 home"
    >
      <span className="inline-flex items-center rounded-lg bg-ink-900/90 px-2.5 py-1.5 dark:bg-transparent dark:px-0 dark:py-0">
        <img
          src={LOGO_SRC}
          alt="ISBM Bangkok 2026"
          width={180}
          height={54}
          className={cn(
            'h-11 sm:h-12 lg:h-[3.375rem] w-auto object-contain transition-opacity group-hover:opacity-90',
            className,
          )}
          loading="eager"
          decoding="async"
        />
      </span>
    </Link>
  );
}
